import { Controller } from "@hotwired/stimulus"

// The offering page's quantity (TMS-1680): as the stepper changes, Add to Cart and Buy Now carry
// the new quantity, Buy Now shows the total, and two or more say they are licences for other
// people. Without JavaScript both forms post the starting quantity.
export default class extends Controller {
  static targets = ["field", "total", "note"]
  static values = { unitCents: Number }

  changed(event) {
    const quantity = event.detail?.value
    if (!Number.isInteger(quantity)) return

    this.fieldTargets.forEach((field) => { field.value = quantity })
    this.totalTargets.forEach((total) => { total.textContent = this.currency(this.unitCentsValue * quantity) })
    this.noteTargets.forEach((note) => { note.hidden = quantity < 2 })
  }

  currency(cents) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100)
  }
}
